
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@/utils/decorator";
import {
  emptyToLine,
  splitThousands,
  booleanFormat,
  enterWeComFormat,
  downloadAppFormat,
  followOfficialAccountFormat
} from "@/utils/common";
import DataImport from "@/components/scope/data-import.vue";
import SwitchStatus from "@/components/scope/switch-status.vue";
import t from "@common/src/i18n/t";
import dayjs from "dayjs";

const customer = namespace("customer");

@Component({
  components: { DataImport, SwitchStatus }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("v210906.please-select-at-least-one-customer"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
@Table.DataImport({
  templateUrl: "https://speedbiz-public.oss-cn-beijing.aliyuncs.com/static/template/speedbiz/客户车辆导入.xlsx",
  actionUrl: "/filecloud/importCustomerVehicles"
})
export default class Customer extends Vue {
  dayjs = dayjs;
  @customer.Action getNewCustomerList;
  splitThousands = splitThousands;
  @customer.Action updateCustomerStatus;
  @customer.Action batchUpdateVehicleStatus;
  emptyToLine = emptyToLine;
  searchForm = {
    customerName: "",
    mobile: "",
    businessSource: ""
  };
  customerList: any[] = [];
  searchList: any[] = [
    {
      label: "用户名称",
      type: "input",
      value: "",
      prop: "customerName"
    },
    {
      label: t("base.phone"),
      type: "input",
      value: "",
      prop: "mobile"
    },
    {
      label: "业务来源",
      type: "input",
      value: "",
      prop: "businessSource"
    },
    {
      label: "经验值等级",
      type: "select",
      selectList: [
        {
          label: "1",
          value: "1"
        },
        {
          label: "2",
          value: "2"
        },
        {
          label: "3",
          value: "3"
        },
        {
          label: "4",
          value: "4"
        }
      ],
      value: "",
      prop: "level"
    }
  ];
  mix_total: number = 0;

  // 新增属性
  visibleColumns: string[] = ['基本信息', '消费数据', '用户状态', '会员信息'];
  expandedRow: any = null;

  created() {
    this.init();
  }

  // 判断列是否可见
  isColumnVisible(columnName: string): boolean {
    return this.visibleColumns.includes(columnName);
  }

  // 表格行样式
  tableRowClassName({row, rowIndex}): string {
    if (this.expandedRow && this.expandedRow.phone === row.phone) {
      return 'expanded-row-class';
    }
    return '';
  }

  // 处理行点击
  handleRowClick(row, column, event) {
    // 如果点击的是操作列，不展开行
    if (column.property === 'operation') {
      return;
    }

    if (this.expandedRow && this.expandedRow.phone === row.phone) {
      this.expandedRow = null;
    } else {
      this.expandedRow = row;
    }
  }

  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }

  handleSizeChange(val: number) {
    this.mix_pageSize = val;
    this.loadListData();
  }

  handleCurrentChange(val: number) {
    this.mix_pageNum = val;
    this.loadListData();
  }

  @Table.LoadDataMethod()
  loadListData() {
    return this.getNewCustomerList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.customerList = data.data.list;
      this.mix_total = data.data.total;
      return data;
    });
  }
  init() {
    this.loadListData();
  }
}
